import { Link, NavLink } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { useMessages } from '../stores/messages.js';

/**
 * L'accès à la boîte de réception. Une cloche, pas une entrée de nav : la nav ne porte que
 * les destinations quotidiennes (ADR 0007), un accusé de réception est du chrome (ADR 0008 § 3).
 */
export function MessagesBell({
  variant,
  onNavigate,
}: {
  variant: 'icon' | 'row';
  onNavigate?: (() => void) | undefined;
}): React.ReactElement {
  const unread = useMessages((s) => s.unread);
  const label = unread > 0 ? `Messages, ${unread} non lus` : 'Messages';
  const badge = unread > 9 ? '9+' : String(unread);

  if (variant === 'row') {
    return (
      <NavLink to="/messages" onClick={onNavigate} aria-label={label} className="navigation-lien">
        <Bell size={16} aria-hidden />
        Messages
        {unread > 0 && <span className="etiquette etiquette-marque">{badge}</span>}
      </NavLink>
    );
  }

  // `.pastille` du kit : un point, pas un nombre — c'est `aria-label` qui dit combien attendent.
  return (
    <Link
      to="/messages"
      onClick={onNavigate}
      aria-label={label}
      className="bouton bouton-discret bouton-icone"
    >
      <Bell size={20} aria-hidden />
      {unread > 0 && <span className="pastille" />}
    </Link>
  );
}
